import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Grid,
	Button
} from "@material-ui/core";

import Timestamp from './Timestamp';

const styles = makeStyles(theme => ({
	mainMessage: {
		marginTop: '.5em',
		backgroundColor: '#ff000012',
		borderRadius: '10px',
		padding: '5px'
	},
	previousCommentsWrapper: {
		paddingTop: '1em'
	},
	hidePrevious: {
		"-webkit-mask-image": "linear-gradient(to bottom, #00000075, #0000003d 50%, #00000000)"
	},
	author: {
		paddingRight: "0.5em",
		fontSize: "0.9rem",
		fontWeight: "460"
	},
	sameAuthor: {
		fontWeight: "bold"
	},
	prevCommentTimestamp: {
		paddingTop: '1px',
		color: 'grey'
	},
	viewButtonContainer: {
		height: '17px',
		textAlign: 'center'
	},
	viewButtonAbsoluteContainer: {
		width: '66%',
		height: '17px',
		position: 'absolute',
		textAlign: 'end',
		bottom: '18px',
	},
	viewButtonBackground: {
		background: '#ffffff5c',
    	display: 'inline-block'
	}
}));

function GoogleChatContent(props) {
	console.log('google chat content');
	const [viewPrevious, setViewPrevious] = useState(false);

	let classes = styles(),
		{content, previousMessages, extraHeaders} = props;
	
	let historyType = null;
	if (previousMessages.length > 0) {
		historyType = previousMessages[0].type;
	}

	console.log('historyType', historyType);
	
	const chatMessage = (message) => {
		const {from, content, timestamp, sameAuthor} = message;
		return (
			<Grid item>
				<Grid container>
					<Grid item className={`${classes.author} ${sameAuthor ? classes.sameAuthor : null}`}>{from}</Grid>
					<Grid item><Timestamp className={classes.prevCommentTimestamp} time={timestamp} reducedSize={false} reducedSize2={true} format="MMM dd, h:mma" /></Grid>
				</Grid>
				<div item className={classes.prevComment}>{content}</div>
			</Grid>
		)
	}

	const ToggleButton = (props) => {
		let displayText = null, {viewPrevious, length, onClick, historyType} = props;

		if (viewPrevious) {
			displayText = 'Hide Comments';
		}
		else {

			displayText = 'View Prior ' + historyType + ' Comments (' + length + ')';
		}

		return (
			<div>
				<Button color="primary" onClick={onClick}>
					{displayText}
				</Button>
			</div>
		)
	}

	const togglePreviousCommentsView = (viewPrevious) => {
		setViewPrevious(!viewPrevious)
	}

	const mainMessage = chatMessage({
		content,
		from: extraHeaders.from?.substr(1)?.slice(0, -1),
		sameAuthor: true,
		timestamp: extraHeaders.sent
	});

	return (
		<React.Fragment>
			<div className={classes.mainMessage}>{mainMessage}</div>
			{previousMessages.length > 0 ?
				<div>
					<Grid container direction="column" spacing={2} className={`${!viewPrevious ? classes.hidePrevious : null} ${classes.previousCommentsWrapper}`}>
						{
							previousMessages.map((message, idx) => {
								if (idx >= 1 && !viewPrevious) {
									return null;
								}
								else {
									return chatMessage(message);
								}
							})
						}
					</Grid>
					{
						!viewPrevious ?
						<div className={classes.viewButtonContainer}>
							<div className={classes.viewButtonAbsoluteContainer}>
								<span className={classes.viewButtonBackground}>
									<ToggleButton onClick={() => togglePreviousCommentsView(viewPrevious)} historyType={historyType} viewPrevious={viewPrevious} length={previousMessages.length} />
								</span>
							</div>
						</div>
						:
						<div className={classes.viewButtonContainer}>
							<ToggleButton onClick={() => togglePreviousCommentsView(viewPrevious)} historyType={historyType} viewPrevious={viewPrevious} length={previousMessages.length} />
						</div>
					}
				</div>
				: null
			}
		</React.Fragment>
	);
}

GoogleChatContent.propTypes = {
	content: PropTypes.string,
	previousMessages: PropTypes.array,
	extraHeaders: PropTypes.object
};

export default GoogleChatContent;
